import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useUserStore } from '@/store/user';
import { computed, ref, withDefaults } from 'vue';
import _ from 'lodash';
import { RelationUserCompany } from '@/graphql/types/graphql';

interface UserCompanySelectorProps {
    value: RelationUserCompany | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCompaniesSelector',
  props: {
    value: { default: null }
  },
  emits: ['select'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

let userStore = useUserStore();

const props = __props;

const model = computed({
    get() {
        return props.value?.companyName;
    },
    set(newValue) {
        const company = _.find(userStore.allCompanies, {
            companyName: newValue,
        }) as RelationUserCompany;
        emit('select', company);
    },
});

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    items: _unref(userStore).filteredCompany,
    "hide-no-data": "",
    underlined: "",
    clearable: "",
    "hide-selected": "",
    color: "primary",
    class: "no-padding-start",
    label: _ctx.$t('company'),
    placeholder: _ctx.$t('company')
  }, null, 8, ["modelValue", "items", "label", "placeholder"]))
}
}

})